module.exports = "/_next/static/images/comprehensive-water-solutions-e4f4438a22dcff114e443165437839d8.webp";